import OrderManagement from './OrderManagement.vue';

export default OrderManagement;
